import { ErrorOption } from "react-hook-form";
import { OrderConfirmationFormType } from "../../ConfirmOrderForm";

type FulfillmentChangeField =
  | "fulfillmentChangeAcknowledged"
  | "fulfillmentChangeReason"
  | "fulfillmentChangeReasonMessage";

type FulfillmentChangeData = Pick<
  OrderConfirmationFormType,
  | "fulfillmentChangeAcknowledged"
  | "fulfillmentChangeReason"
  | "fulfillmentChangeReasonMessage"
>;

type FulfillmentChangeValidationResult =
  | {
      success: true;
      data: FulfillmentChangeData;
    }
  | {
      success: false;
      errors: Array<[FulfillmentChangeField, ErrorOption]>;
    };

export const validateFulfillmentTypeChange = ({
  data,
  isSwitchingBuyerOrderFromSellarDistribution,
}: {
  data: FulfillmentChangeData;
  isSwitchingBuyerOrderFromSellarDistribution: boolean;
}): FulfillmentChangeValidationResult => {
  if (!isSwitchingBuyerOrderFromSellarDistribution) {
    return { success: true, data };
  }

  const errors: Array<[FulfillmentChangeField, ErrorOption]> = [];

  if (!data.fulfillmentChangeAcknowledged) {
    errors.push([
      "fulfillmentChangeAcknowledged",
      {
        type: "required",
        message: "You must acknowledge this change to proceed",
      },
    ]);
  }

  if (!data.fulfillmentChangeReason) {
    errors.push([
      "fulfillmentChangeReason",
      {
        type: "required",
        message: "You must select a reason for this change",
      },
    ]);
  }

  const trimmedFulfillmentChangeReasonMessage =
    data.fulfillmentChangeReasonMessage.trim();

  if (!trimmedFulfillmentChangeReasonMessage) {
    errors.push([
      "fulfillmentChangeReasonMessage",
      {
        type: "required",
        message: "Please provide additional information about this change",
      },
    ]);
  }

  return errors.length > 0
    ? { success: false, errors }
    : { success: true, data };
};
